import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { StaticRouter } from 'react-router';
import { Router } from 'react-router-dom';
import configureStore from './store/configureStore';
import i18nClient from './i18n/client';
import i18nServer from './i18n/server';
import App from './App';
import { MSTProvider, rootStore, history } from '@src/models';

const Root = ({ railsContext, cookiePolicySSR, ...props }) => {
  const { serverSide, location, i18nLocale } = railsContext || {};
  if (serverSide) {
    const context = {};
    const store = configureStore(props);
    return (
      <I18nextProvider i18n={i18nServer(i18nLocale)}>
        <ReduxProvider store={store}>
          <StaticRouter context={context} location={location}>
            <App cookiePolicySSR={cookiePolicySSR} />
          </StaticRouter>
        </ReduxProvider>
      </I18nextProvider>
    );
  }
  const store = configureStore(props);

  return (
    <I18nextProvider i18n={i18nClient(i18nLocale)}>
      <MSTProvider value={rootStore}>
        <ReduxProvider store={store}>
          <Router history={history}>
            <App />
          </Router>
        </ReduxProvider>
      </MSTProvider>
    </I18nextProvider>
  );
};

Root.propTypes = {
  railsContext: PropTypes.shape({
    serverSide: PropTypes.bool.isRequired,
    location: PropTypes.string.isRequired,
    i18nLocale: PropTypes.string.isRequired
  })
};

const renderComponent = () => {
  ReactDOM.render(<Root />, document.getElementById('super'));
};

const railsGeneratorFunc = (props, railsContext) => <Root {...props} railsContext={railsContext} />;

// Hot reload API
if (module.hot) {
  module.hot.accept('./App', () => {
    renderComponent();
  });
}

export default module.hot ? renderComponent : railsGeneratorFunc;